import React, { useState, forwardRef } from 'react';
import classNames from 'classnames';
import ErrorMessage from './ErrorMessage';
import Icon from '../_HumanWritten/Icon/Icon';

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	label: string;
	error?: string;
	required?: boolean;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
	({ label, error, required, className, id, ...props }, ref) => {
		const [showPassword, setShowPassword] = useState(false);
		const inputId = id || label.replace(/\s+/g, '-').toLowerCase();

		const toggleVisibility = () => {
			setShowPassword(!showPassword);
		};

		return (
			<div className="flex flex-col gap-1 w-full">
				<label htmlFor={inputId} className="text-sm text-gray-800">
					{label} {required && <span className="text-[var(--colour-brand-primary)]">*</span>}
				</label>
				<div className="relative custom-input">
					<input
						id={inputId}
						ref={ref}
						type={showPassword ? 'text' : 'password'}
						className={classNames(
							'px-3 py-3 border rounded-md outline-none transition-all w-full pr-10',
							'placeholder:text-gray-400 text-sm',
							// eslint-disable-next-line no-nested-ternary
							props.disabled
								? 'border-gray-300 bg-gray-100 cursor-not-allowed text-gray-500 placeholder:text-gray-300'
								: error
									? 'border-red-400 bg-red-50 text-red-900 focus:border-red-400 focus:ring-1 focus:ring-[#ef4444]'
									: 'border-gray-300 hover:border-gray-400 focus:border-[var(--colour-brand-primary)] focus:ring-1 focus:ring-[var(--colour-brand-primary)]',
							props.readOnly && 'bg-gray-50 text-gray-600',
							className,
						)}
						{...props}
					/>
					<button
						type="button"
						onClick={toggleVisibility}
						className={classNames(
							'absolute right-3 top-1/2 -translate-y-1/2 !h-auto focus:outline-none',
							props.disabled ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:text-gray-700',
						)}
						tabIndex={-1}
						disabled={props.disabled}
					>
						<Icon
							name={showPassword ? 'visibility_off' : 'visibility'}
							useMaterialIcons
							classname="text-xl"
						/>
					</button>
				</div>
				<ErrorMessage error={error} />
			</div>
		);
	},
);
